import { createContext } from "react";

export const GroupLayerContext = createContext({
  exists: false,
  childLayers: undefined
})
